export const getVal = (obj, key) => {
  if (!obj) return undefined;
  if (key.indexOf(".") < 0) return obj[key];
  const currentKey = key.substring(0, key.indexOf("."));
  const nextKey = key.substring(key.indexOf(".") + 1);
  const val = obj[currentKey];
  if (!nextKey) return val;
  return getVal(val, nextKey);
};
